import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["attacksContainer", "template", "modesContainer", "modeTemplate"];

  connect() {
    document.addEventListener("attack-selected", this.handleAttackSelected.bind(this));
  }

  disconnect() {
    document.removeEventListener("attack-selected", this.handleAttackSelected.bind(this));
  }

  add() {
    // Clone the template content
    const template = this.templateTarget.innerHTML;

    // Generate a unique ID for this nested attack
    const uniqueId = new Date().getTime();

    // Replace all occurrences of NEW_RECORD in the template with the unique ID
    const newTemplate = template.replace(/NEW_RECORD/g, uniqueId);

    // Append the processed template to the container
    this.attacksContainerTarget.insertAdjacentHTML("beforeend", newTemplate);
  }

  addMode(event) {
    // Find the closest modes container to the clicked button
    const modesContainer = event.target.closest('[data-attack-modes-target="container"]');
    const modeTemplate = event.target.closest('.attack-fields').querySelector('[data-attack-modes-target="template"]');

    // Generate a unique ID for this nested mode
    const uniqueId = new Date().getTime();

    // Replace all occurrences of NEW_MODE in the template with the unique ID
    const newTemplate = modeTemplate.innerHTML.replace(/NEW_MODE/g, uniqueId);

    // Append the processed template to the container
    modesContainer.insertAdjacentHTML("beforeend", newTemplate);
  }

  removeMode(event) {
    const modeField = event.target.closest('.mode-fields');
    modeField.remove();
  }

  handleAttackSelected(event) {
    const attack = event.detail.attack;
    this.add();

    // Fill in the form fields
    const formGroup = this.attacksContainerTarget.lastElementChild;
    this.fillAttackForm(formGroup, attack);
  }

  fillAttackForm(formGroup, attack) {
    // Helper to find and set input values
    const setField = (name, value) => {
      const input = formGroup.querySelector(`[name$="[${name}]"]`);
      if (input) input.value = value;
    };

    // Set basic attack fields
    setField("name", attack.name);
    setField("attack_type", attack.attack_type);
    setField("attack_value", attack.attack_value);
    setField("penetration", attack.penetration);
    setField("hardening", attack.hardening);
    setField("area_of_effect", attack.area_of_effect);
    setField("attack_notes", attack.attack_notes);

    // Set damage fields
    setField("damage_value", attack.damage_value);
    setField("damage_dice_count", attack.damage_dice_count);
    setField("damage_dice_type", attack.damage_dice_type);
    setField("damage_modifier", attack.damage_modifier);

    // Add attack modes if present
    if (attack.attack_modes?.length > 0) {
      const modesContainer = formGroup.querySelector('[data-attack-modes-target="container"]');
      const modeTemplate = formGroup.querySelector('[data-attack-modes-target="template"]');

      attack.attack_modes.forEach((mode) => {
        const newMode = modeTemplate.innerHTML.replace(/NEW_MODE/g, new Date().getTime());
        modesContainer.insertAdjacentHTML("beforeend", newMode);

        const modeGroup = modesContainer.lastElementChild;
        this.fillModeForm(modeGroup, mode);
      });
    }
  }

  fillModeForm(modeGroup, mode) {
    const setField = (name, value) => {
      const input = modeGroup.querySelector(`[name$="[${name}]"]`);
      if (input) input.value = value;
    };

    setField("name", mode.name);
    setField("notes", mode.notes);
    setField("attack_value", mode.attack_value);
    setField("damage_value", mode.damage_value);
    setField("damage_dice_count", mode.damage_dice_count);
    setField("damage_dice_type", mode.damage_dice_type);
    setField("damage_modifier", mode.damage_modifier);
  }

  removeAttack(event) {
    const attackField = event.target.closest('.attack-fields');
    attackField.remove();
  }
}
